import { t } from '../../../locale';
import { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  message?: ValidationMessage;
}

export default function positiveNumber(config: Config = {}): ValidationRule {
  return {
    name: 'positiveNumber',
    validator(value) {
      return !isDefined(value) || Number(value) > 0;
    },
    message: config.message || t('ll.validation.positiveNumber'),
  };
}
